import React from 'react'
import styled from 'styled-components'
import logoImg from '../assets/logo.png'


const Logo = styled.div.attrs({ className: 'col'})`
  text-align: center;
  padding-top: 31px;
`

const AlephLogo = () => <div className="row">
  <Logo><img src={logoImg} alt="Aleph VC"/> </Logo>
</div>


export default AlephLogo



// WEBPACK FOOTER //
// ./src/components/logo.js